/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * @module bulb-media-embed/bulbmediaembed
 */

import { Plugin } from 'ckeditor5';
import BulbMediaEmbedEditing from './bulbmediaembedediting';
import BulbMediaEmbedToolbar from './bulbmediaembedtoolbar';
import BulbMediaEmbedUI from './bulbmediaembedui';

/**
 * The media embed plugin for Bulb's CKEditor.
 *
 * @extends Plugin
 */
export default class BulbMediaEmbed extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbMediaEmbedEditing, BulbMediaEmbedToolbar, BulbMediaEmbedUI] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbMediaEmbed' as const;
  }
}
